import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { ResourceManagerService } from '@barthauer/abc/core/resources';
import { BasysMapFrameService } from '@barthauer/basys/map-frame';
import { ResourceEventEditBase } from '../resource-event-edit-base/resource-event-edit-base.component';
import { ResourcesService } from '../resources.service';

@Component({
  selector: 'app-resource-event-personnel-working-times',
  templateUrl: './resource-event-personnel-working-times.component.html',
  styleUrls: ['./resource-event-personnel-working-times.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class ResourceEventPersonnelWorkingTimesComponent extends ResourceEventEditBase implements OnInit, OnDestroy {
  constructor(
    resourceManagerService: ResourceManagerService,
    resourcesService: ResourcesService,
    frame: BasysMapFrameService
  ) {
    super();
    super.init(frame, resourcesService, resourceManagerService);
  }

  async ngOnInit() {
    super.ngOnInit();
  }
  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
